import { render, staticRenderFns } from "./coaching_request.vue?vue&type=template&id=57284772"
import script from "./coaching_request.vue?vue&type=script&lang=js"
export * from "./coaching_request.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports